<template>
  <div
    class="tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center tw-text-center"
  >
    <div v-if="step == 1">
      <div class="tw-my-8">
        <div v-if="userFullName">Hello {{ userFullName }}</div>
      </div>
      <div class="tw-my-8">
        <button
          class="sf-btn-primary"
          v-on:click.prevent="handleSetMode('practice')"
        >
          Begin Practice
        </button>
        <button
          class="sf-btn-primary"
          v-on:click.prevent="handleSetMode('test')"
        >
          Begin Test
        </button>
      </div>
    </div>
    <div v-else-if="loadingProgress >= 0 && loadingProgress < 1">
      loading {{ Math.floor(loadingProgress * 100) }}%
    </div>
    <ReadQuestions
      v-if="step == 2 && loadingProgress >= 1"
      @select="handleRedSentences"
    />
  </div>
</template>

<script lang="ts">
import {
  sfActivityLoadProgress,
  sfInitActivity,
  sfStartActivity,
} from "@/state/sfActivityState";
import { SfActivityMode } from "@/types/sfActivityTypes";
import { defineComponent } from "vue";
import ReadQuestions from "../activity-components/ReadQuestions.vue";
import { sfStopActivityAudio } from "@/state/sfActivityState";

export default defineComponent({
  components: { ReadQuestions },
  props: { userFullName: String },
  data: function () {
    return {
      step: 1,
    };
  },
  computed: {
    loadingProgress(): number {
      return sfActivityLoadProgress.value;
    },
  },
  methods: {
    handleSetMode(mode: SfActivityMode) {
      sfInitActivity(mode);
      this.step = 2;
    },
    handleRedSentences(readSentences: boolean) {
      sfStopActivityAudio();
      sfStartActivity(readSentences);
    },
  },
});
</script>
